import styled from 'styled-components';

export const InfoButton = styled.button`
  position: relative;
  margin-left: 5px;
`;

export default InfoButton;
